export const COLORS = {
  primary : '#E21608',
  secondary : 'rgb(224,27,27)',
  back : 'rgb(0,0,0)',
  white: '#F2F2F2' 
};